import React from "react";
import { Header } from "../../../components/Header";
import { SolutionBanner } from "../../../blocks/solution-banner";
// import { CommonBanner } from "../../blocks/common-banner";
import { SolutionHot } from "../../../blocks/solution-hot";

// import { SolutionScene } from "../../../blocks/solution-scene";
import { SolutionCustomer } from "../../../blocks/solution-customer";
// import { Helmet } from "react-helmet";
import "./styles.less";
import { Footer } from "../../../components/Footer";

export const SolutionList = () => {
  return (
    <div className="solution-page">
      {/* <Helmet>
        <title>Authing 提供行业解决方案 - 零信任 - 零信任网络 - 零信任方</title>
      </Helmet> */}
      <Header mode={"light"} />
      <SolutionBanner />
      <SolutionHot />
      {/* <SolutionScene /> */}
      <SolutionCustomer />
      <Footer />
    </div>
  );
};
